import { ImileBaixaSection } from "./components/imile-baixa-section";
import { useImileBaixa } from "./hooks/use-imile-baixa";

export default function ImileBaixaResolution() {
  const {
    opsList,
    baixaList,
    selectedOps,
    setSelectedOps,
    isLoadingOps,
    isLoadingBaixas,
    startDoc,
    submitDb,
    isStartingDoc,
    isSubmittingDb,
  } = useImileBaixa();

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">iMile Baixa</h1>
        <p className="text-muted-foreground mt-1">
          Resolver pendências das baixas de iMile. A baixa pode ser feita antes
          do vencimento — o popup avisa quando for o caso.
        </p>
      </div>

      <ImileBaixaSection
        opsList={opsList}
        baixaList={baixaList}
        selectedOps={selectedOps}
        onSelectionChange={setSelectedOps}
        isLoadingOps={isLoadingOps}
        isLoadingBaixas={isLoadingBaixas}
        onStartDoc={startDoc}
        onSubmitDb={submitDb}
        isStartingDoc={isStartingDoc}
        isSubmittingDb={isSubmittingDb}
      />
    </div>
  );
}
